import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,DatePicker, 
  KeyboardDatePicker,
  DateTimePicker
} from '@material-ui/pickers';
import calenderimg from './images/calender-icon.png';
import { addDays } from "date-fns";
import Moment from 'react-moment';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles } from '@mui/styles'; 
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class  AddPortionsbox extends Component {

  constructor(props) {
      super(props)
	   this.mydrpChangeHandler = this.mydrpChangeHandler.bind(this);
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
      this.state = {
		  
		   open:false,title:'',poa_id:0,notype:0,ispanel:false,chapters:'',errormessage:'',erropen:false,classesarray:[],classes:'',rolelabel:'Select Class',
		   batcharray:[],batch:'',rolelabel:'Select Batch',userarray:[],user:'',rolelabel:'Select Teacher',
			brancharray:[],branch:'',subjectarray:[],subject:'',rolelabel:'Select Subject',enddate:Date.now(),enddate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),startdate:Date.now(),startdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
	  branchlabel:'Select Branch',}
      
  }
handleNotifypanel=()=>{
	this.setState({ ispanel:!this.state.ispanel});  
	  
}
handfrChanges = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ startdate:date,
startdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  handenddateChanges = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ enddate:date,
enddate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  


 Downloadsgetdata() {
	//var self=this;
  if(this.props.id!==0)
  {
	
	   axios.get(Serverurl+'ajaxportionsassigned.php?action=list&poa_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){	
	
	

		
  this.setState({
     
      poa_id:resp.data[0].poa_id,
	  user:resp.data[0].poa_ur_id,
	  batch:resp.data[0].poa_bc_id,
	  subject:resp.data[0].poa_sb_id,
	  title: resp.data[0].poa_title,  
	  chapters:resp.data[0].poa_chapters, 
	 startdate1: resp.data[0].poa_startdate,	
	 startdate:resp.data[0].poa_startdate,
	 enddate:resp.data[0].poa_enddate,
	 enddate1:resp.data[0].poa_enddate,
	 branch:resp.data[0].ur_br_id,
	 
    },()=>{ 
	this.onloadteacherbind(); });	 
	
  }  
});

	
  }else{
	 this.setState({  
	  poa_id:0,
	  title: '',
	 chapters:'', 
	 classes:'',
	user:'',
	startdate1:'',
	enddate1:'',
	 
	  }); 
 }

    
    }

   
 
mydrpChangeHandler = (event) => {
   let name = event.target.name;
        let val = event.target.value;
        
        this.setState({ [name]: val }, () => {
            console.log(`${name} selected: ${val}`);
            if (name === 'branch') {
               
                this.onloadteacherbind(); 
            }

            
            if (name === 'user') {
                this.onloadbatchbind(); 
            }
            if (name === 'batch') {
                this.onloadsubjectbind(); 
            }
        });
}
myChangeHandler = (event) => {
    let name = event.target.name;
    let val = event.target.value;  

    this.setState({ [name]: val } , () =>{ 
	if (localStorage.getItem("MMCuserid") === "1") {
            this.onloadbranchbind(); 

            if (name === 'branch') {
                this.onloadteacherbind();
            }
        }
	});

  
}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
  onloadbranchbind(){
	 let strbranch=localStorage.getItem("MMCbranchid");
 if(localStorage.getItem("MMCrole")==="1")
	 
		  {
			 strbranch=""; 
		  }
    axios.get(Serverurl+'ajaxbranch.php?action=getall&br_id='+strbranch)
	
    
      .then((response) => {    
     
      this.setState({  brancharray: response.data, branch:response.data[0]["br_id"] });
      })   
    
      .then(data => {
        let roleFromApi = this.state.brancharray.map(branch => {
                            
          return {value: branch.br_id, display:branch.br_title}
        });
      
		
        this.setState({
          brancharray: [{value: '', display: 'Select Branch'}].concat(roleFromApi)
        });
      })
} 

  onloadteacherbind(){
	 let strbranch;
	if(localStorage.getItem("MMCrole")==="1")
	 
		  {
			  strbranch=this.state.branch; 
			
		  }
		  else{
			 
		   strbranch=localStorage.getItem("MMCbranchid");
		  }

    axios.get(Serverurl+'ajaxteachersubject.php?action=teacherbind&ur_role=3&ur_br_id='+strbranch)
	
    
      .then((response) => {    
     
      this.setState({  userarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.userarray.map(user => {
                            
          return {value: user.ur_id, display:user.ur_name}
        });
      
		
        this.setState({
          userarray: [{value: '0', display: 'Select Teacher'}].concat(roleFromApi)
        });
      })
	 
  this.onloadbatchbind();
  
  }
 onloadbatchbind(){	
	 let strbranch;
	if(localStorage.getItem("MMCrole")==="1")
	 
		  {
			  strbranch=this.state.branch; 
			
		  }
		  else{
		   strbranch=localStorage.getItem("MMCbranchid");
		  }
		   
	let strurl="";

			  strurl='action=teacherwisebatch&ts_ur_id='+this.state.user+'&bc_br_id='+strbranch;
		  
    axios.get(Serverurl+'ajaxbatch.php?'+strurl)
	
    
      .then((response) => {    
     
      this.setState({  batcharray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.batcharray.map(batch => {
                            
          return {value: batch.bc_id, display:batch.tc_title+"-"+batch.bc_title}
        });
      
		
        this.setState({
          batcharray: [{value: '', display: 'Select Batch'}].concat(roleFromApi)
        });
      })
 this.onloadsubjectbind();

} 

 onloadsubjectbind(){
	
axios.get(Serverurl+'ajaxteachersubject.php?action=teacherwisesubject&ts_ur_id='+this.state.user+'&ts_bc_id='+this.state.batch)
  .then((response) => {      
     
      this.setState({  subjectarray: response.data,  },()=>{
		  
		   let roleFromApi = this.state.subjectarray.map(subject => {                            
          return {value: subject.sb_id, display:subject.sb_title}
        });
		 this.setState({
          subjectarray: [{value: '', display: 'Select Subject'}].concat(roleFromApi)
        },()=>{ });
		  
		  
	  });
      })   
    
      


} 
  

handledelete = (e) => {
	 if(this.props.id!==0)
  {  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('poa_id',this.props.id)
	 	   
	formData.append('userid',localStorage.getItem("MMCuserid"))
	
	
	 axios.post(Serverurl+"ajaxportionsassigned.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    	this.props.updateDonenew();
  
    
            });
		
	this.setState({ open:false });
 }
      
  }	  
 }
handleClickOpen = (e) => {

  this.setState({open:!this.state.open,ispanel:false,  title:'',address:'',remainderdate:'',errormessage:'',erropen:false,classesarray:[],classes:'',trust:'',
  branch:'',subject:'',startdate1:'',startdate:'',syllabustype:'',
	  });
	  if(localStorage.getItem("MMCuserid")==="1")
	  {
	  this.onloadbranchbind();
	  }
	  else if(this.props.id !== 0)
	  {
		 

		  
	this.Downloadsgetdata();		
	
	  }	
	  else{
		  this.onloadteacherbind();
	  }
	
	
		this.setState({startdate1:this.props.celldate,startdate:this.props.edate,enddate1:this.props.celldate,enddate:this.props.edate});	
		
		
	
		
		};

handleClose = (e) => {
	
	
	let teacher=this.state.user;
	
	let subject=this.state.subject;
	
 let title = this.state.title;
 let chapters=this.state.chapters;

let startdate1=this.state.startdate1;

let enddate1=this.state.enddate1;
if(teacher==="")
{
	
	this.setState({errormessage:"Please Select Teacher",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(chapters==="")
{
	
	this.setState({errormessage:"Please Enter Chapters",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}




   var formData = new FormData();
  
  
   if(this.state.poa_id==0)
	  {
		  formData.append('poa_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('poa_id',this.state.poa_id)
		
      }	  

        formData.append('action','insertorupdate') 
		formData.append('poa_ur_id',teacher)
		formData.append('poa_sb_id',subject)
		formData.append('poa_title',title)
		formData.append('poa_chapters',chapters)
		formData.append('poa_startdate',startdate1)
		formData.append('poa_enddate',enddate1)	  
		formData.append('userid',localStorage.getItem("MMCuserid"))
		  
		  formData.append('poa_bc_id',this.state.batch)
		axios.post(Serverurl+"ajaxportionsassigned.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:!this.state.open });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
	 
  } 
	
	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title" className="dwnloadspanel">
      <DialogTitle id="form-dialog-title"> 
	  
	 <h2> Assign Portions </h2>
	 
	  </DialogTitle>
      <DialogContent>
	  
<div className="formlists">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
		

	
	
	
						  
						  	

	<div className="optionstypedrp">
	{(localStorage.getItem("MMCrole")==="1") &&(<React.Fragment>
	 <p> <span className="validation">*</span>Branch</p>
	<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branch }}
          onChange={this.mydrpChangeHandler}
          id="branch"
		   value={this.state.branch}
		  name="branch"
		
		
        >
		{this.state.brancharray.map(branch => (
            <option  
            
              value={branch.value}
            >
              {branch.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	</React.Fragment>)}
	 <p> <span className="validation">*</span>Teacher</p>
	<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.user }}
          onChange={this.mydrpChangeHandler}
          id="user"
		   value={this.state.user}
		  name="user"
		
		
        >
		{this.state.userarray.map(user => (
            <option  
            
              value={user.value}
            >
              {user.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>	
		
	 <p> <span className="validation">*</span>Batch</p>
	<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		 
          onChange={this.mydrpChangeHandler}
          id="batch"
		   value={this.state.batch}
		  name="batch"
		
		
        >
		{this.state.batcharray.map(batch => (
            <option  
            
              value={batch.value}
            >
              {batch.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
		
						  
	<p> <span className="validation">*</span>Subject</p>
		<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.subject }}
          onChange={this.mydrpChangeHandler}
          id="subject"
		   value={this.state.subject}
		  name="subject"
		
		
        >
		{this.state.subjectarray.map(subject => (
            <option  
            
              value={subject.value}
            >
              {subject.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
	  <p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
	 <p> <span className="validation">*</span>Chapters</p>
		<p><TextField name="chapters" 
		multiline
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.chapters}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2"}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>					  
				
			<p>Start Date
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">	 
      <DatePicker fullWidth
        value={this.state.startdate || Date.now()}
        onChange={this.handfrChanges}
		variant="inline"
		inputVariant="outlined"
		 margin="normal"            
            format="dd/MM/yyyy"			
        autoOk name="startdate"
        ampm={false}
		
      />
	   </Grid>
    </MuiPickersUtilsProvider></p>	

	 <p> End Date
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">	 
      <DatePicker fullWidth minDate={this.state.startdate}
        value={this.state.enddate || Date.now()}
        onChange={this.handenddateChanges}
		variant="inline"
		inputVariant="outlined"
		 margin="normal"            
            format="dd/MM/yyyy"			
        autoOk name="enddate"
        ampm={false}
		disablePast={true}
      />
	   </Grid>
    </MuiPickersUtilsProvider></p>
		
	
		
	
</div>


<div className="clear"></div>
	
	<div className="clear">&nbsp;</div>
		
       <div className="actionbtn">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickOpen} color="secondary" className="frmsecondarybtn">
          Cancel
        </Button>&nbsp;
		
		{this.props.id!==0 && (
        <Button onClick={this.handledelete} color="secondary" className="admsndisablebtn">
          Delete
        </Button>)}
		</div>
<div className="savebtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
	</div>		 
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 
  









